// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, GenerateCsv } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import translate from "@insite/client-framework/Translate";
import { xGoogleAnalyticsState } from "@west/App/Store/Reducers";
import { googleAnalyticsFileDownload } from "@west/XDL/Utilities/tracking";

export const XngGenerateCsv: typeof GenerateCsv = async props => {
    if (!props.dataForUnparse) {
        return;
    }
    const state = props.getState() as xGoogleAnalyticsState;
    const { unparse } = await import(/* webpackChunkName: "papaparse" */ "papaparse");
    const csv = unparse(props.dataForUnparse);
    const csvBlob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });

    const fileName = `wishlist_${props.parameter.wishListId}.csv`;
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(csvBlob);
    downloadLink.setAttribute("download", fileName);
    downloadLink.click();
    // Google Analytics
    googleAnalyticsFileDownload(state.xGoogleAnalytics, translate("Export"), downloadLink.href);
};

replaceInChain(chain, XngGenerateCsv, GenerateCsv);
